import React from "react";
import { Box } from "@mui/material";

export const ballColor = (num, max) => {
  const third = Math.ceil((max || 30) / 3);
  if (num <= third) return { base: "#03B349", dark: "#016A2B" };
  if (num <= third * 2) return { base: "#367AFF", dark: "#123C8C" };
  return { base: "#fa114f", dark: "#8C0325" };
};

const Ball = ({ num, max, size = 44, dim }) => {
  const c = ballColor(num, max);
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 800,
        fontSize: size * 0.38,
        color: "#fff",
        opacity: dim ? 0.35 : 1,
        background: `radial-gradient(circle at 30% 25%, #ffffff66 8%, ${c.base} 40%, ${c.dark} 100%)`,
        boxShadow: "0 4px 10px rgba(0,0,0,0.45), inset 0 -3px 6px rgba(0,0,0,0.3)",
        flexShrink: 0,
      }}
    >
      {num}
    </Box>
  );
};

export default Ball;
